// import React, { useState } from "react";
// import {
//   FaShoppingCart,
//   FaUser,
//   FaBars,
//   FaHeart,
// } from "react-icons/fa";
// import { GrSearch } from "react-icons/gr";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import logo from "../assest/products/extra/logo.jpeg";

// const Header = () => {

//   const navigate = useNavigate();
//   const cartCount = useSelector((state) => state.cart.cartCount);
//   const user = useSelector((state) => state.user.user);
//   const [cartOpen, setCartOpen] = useState(false);

//   const [menuOpen, setMenuOpen] = useState(false);
//   const [search, setSearch] = useState("");

//   const handleSearch = (e) => {
//     e.preventDefault();
//     navigate(`/search?q=${search}`);
//   };

//   return (
//     <>
//       {/* 🔥 DESKTOP HEADER */}
//       <header className="hidden md:block w-full bg-white shadow-sm border-b fixed top-0 z-50">

//         <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

//           {/* LOGO */}
//           <Link to="/">
//             <img src={logo} alt="logo" className="h-10" />
//           </Link>

//           {/* SEARCH */}
//           <form
//             onSubmit={handleSearch}
//             className="flex items-center border-2 border-red-500 rounded-full overflow-hidden w-[500px]"
//           >
//             <select className="px-3 py-2 text-sm outline-none bg-gray-100">
//               <option>All categories</option>
//             </select>

//             <input
//               type="text"
//               placeholder="Search for products"
//               className="flex-1 px-3 py-2 outline-none"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />

//             <button className="bg-red-500 text-white px-5 py-2">
//               <GrSearch />
//             </button>
//           </form>

//           {/* RIGHT */}
//           <div className="flex items-center gap-6 text-sm">

//             <Link to="/login" className="flex flex-col items-center">
//               <FaUser />
//               <span>Sign in</span>
//             </Link>

//             <div className="flex flex-col items-center relative">
//               <FaHeart />
//               <span>Wishlist</span>
//               <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs px-1 rounded-full">
//                 4
//               </span>
//             </div>

//             <Link to="/cart" className="flex flex-col items-center relative">
//               <FaShoppingCart />
//               <span>Cart</span>
//               {cartCount > 0 && (
//                 <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs px-1 rounded-full">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>

//           </div>

//         </div>

//       </header>

//       {/* 🔥 MOBILE HEADER */}
//       <div className="md:hidden fixed top-0 w-full bg-white z-50 shadow flex items-center justify-between px-4 py-3">

//         <img src={logo} alt="logo" className="h-8" />

//         <div className="flex items-center gap-4 text-lg">
//           <FaUser />
//           <Link to="/cart" className="relative">
//             <FaShoppingCart />
//             {cartCount > 0 && (
//               <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1 rounded-full">
//                 {cartCount}
//               </span>
//             )}
//           </Link>

//           <FaBars onClick={() => setMenuOpen(true)} />
//         </div>

//       </div>

//       {/* 🔥 MOBILE DRAWER */}
//       <div className={`fixed top-0 left-0 h-full w-[85%] bg-white z-50 shadow-lg transition-transform ${menuOpen ? "translate-x-0" : "-translate-x-full"}`}>

//         <div className="p-4 border-b flex justify-between">
//           <h2 className="font-bold text-lg">Menu</h2>
//           <button onClick={() => setMenuOpen(false)}>✕</button>
//         </div>

//         {/* SEARCH */}
//         <div className="p-4">
//           <input
//             placeholder="Search..."
//             className="w-full border px-3 py-2 rounded-lg"
//           />
//         </div>

//         {/* MENU */}
//         <div className="px-4 space-y-4 text-sm">

//           <p>Home</p>
//           <p>Shop</p>
//           <p>Product</p>
//           <p>Blog</p>
//           <p>Pages</p>

//         </div>

//         {/* FOOTER */}
//         <div className="absolute bottom-0 w-full border-t p-4 text-sm">
//           <p>USD</p>
//           <p>English</p>
//         </div>

//       </div>

//       {/* 🔥 OVERLAY */}
//       {menuOpen && (
//         <div
//           onClick={() => setMenuOpen(false)}
//           className="fixed inset-0 bg-black/40 z-40"
//         />
//       )}

//       {/* 🔥 BOTTOM NAV (MOBILE) */}
//       <div className="md:hidden fixed bottom-0 w-full bg-white border-t flex justify-around py-2 text-xs z-50">

//         <Link to="/" className="flex flex-col items-center">Home</Link>
//         <Link to="/account" className="flex flex-col items-center">Account</Link>
//         <div className="flex flex-col items-center">Search</div>
//         <div className="flex flex-col items-center relative">
//           Wishlist
//           <span className="absolute -top-1 right-0 text-[10px] bg-red-500 text-white px-1 rounded-full">4</span>
//         </div>
//         <Link to="/cart" className="flex flex-col items-center relative">
//           Cart
//           {cartCount > 0 && (
//             <span className="absolute -top-1 right-0 text-[10px] bg-red-500 text-white px-1 rounded-full">
//               {cartCount}
//             </span>
//           )}
//         </Link>

//       </div>

//     </>
//   );
// };

// export default Header;
import React, { useState } from "react";
import {
  FaShoppingCart,
  FaUser,
  FaBars,
  FaHeart,
} from "react-icons/fa";
import { GrSearch } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logo from "../assest/products/extra/logo.jpeg";
import { logoutUser } from "../store/userSlice";

const Header = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cartCount = useSelector((state) => state.cart.cartCount);
  const user = useSelector((state) => state.user.user);

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search?q=${search}`);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/login");
  };

  return (
    <>
      {/* 🔥 DESKTOP HEADER */}
      <header className="hidden md:block w-full bg-white shadow-sm border-b fixed top-0 z-50">

        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

          {/* LOGO */}
          <Link to="/">
            <img src={logo} alt="logo" className="h-10" />
          </Link>

          {/* SEARCH */}
          <form
            onSubmit={handleSearch}
            className="flex items-center border-2 border-red-500 rounded-full overflow-hidden w-[500px]"
          >
            <input
              type="text"
              placeholder="Search products..."
              className="flex-1 px-3 py-2 outline-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="bg-red-500 text-white px-5 py-2">
              <GrSearch />
            </button>
          </form>

          {/* RIGHT */}
          <div className="flex items-center gap-6 text-sm">

            {/* 🔥 USER SECTION */}
            {user ? (
              <div className="relative">

                <div
                  onClick={() => setDropdown(!dropdown)}
                  className="flex flex-col items-center cursor-pointer"
                >
                  <FaUser />
                  <span className="capitalize">
                    {user.name?.split(" ")[0]}
                  </span>
                </div>

                {/* 🔥 DROPDOWN */}
                {dropdown && (
                  <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-lg p-2 z-50">

                    <Link to="/account/profile" className="block px-3 py-2 hover:bg-gray-100">
                      My Account
                    </Link>

                    <Link to="/account/orders" className="block px-3 py-2 hover:bg-gray-100">
                      Orders
                    </Link>

                    {/* 🔥 ADMIN */}
                    {user.role === "ADMIN" && (
                      <Link to="/admin-panel/dashboard" className="block px-3 py-2 text-blue-600 hover:bg-gray-100">
                        Admin Panel
                      </Link>
                    )}

                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-3 py-2 hover:bg-gray-100 text-red-500"
                    >
                      Logout
                    </button>

                  </div>
                )}

              </div>
            ) : (
              <Link to="/login" className="flex flex-col items-center">
                <FaUser />
                <span>Sign in</span>
              </Link>
            )}

            {/* WISHLIST */}
            <div className="flex flex-col items-center relative cursor-pointer">
              <FaHeart />
              <span>Wishlist</span>
            </div>

            {/* CART */}
            <Link to="/cart" className="flex flex-col items-center relative">
              <FaShoppingCart />
              <span>Cart</span>

              {cartCount > 0 && (
                <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs px-1 rounded-full">
                  {cartCount}
                </span>
              )}
            </Link>

          </div>

        </div>

      </header>

      {/* 🔥 MOBILE HEADER */}
      <div className="md:hidden fixed top-0 w-full bg-white z-50 shadow flex items-center justify-between px-4 py-3">

        <img src={logo} alt="logo" className="h-8" />

        <div className="flex items-center gap-4 text-lg">

          {user ? (
            <Link to="/account/profile">
              <FaUser />
            </Link>
          ) : (
            <Link to="/login">
              <FaUser />
            </Link>
          )}

          <Link to="/cart" className="relative">
            <FaShoppingCart />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1 rounded-full">
                {cartCount}
              </span>
            )}
          </Link>

          <FaBars onClick={() => setMenuOpen(true)} />

        </div>

      </div>

      {/* 🔥 MOBILE DRAWER */}
      <div className={`fixed top-0 left-0 h-full w-[85%] bg-white z-50 shadow-lg transition-transform ${menuOpen ? "translate-x-0" : "-translate-x-full"}`}>

        <div className="p-4 border-b flex justify-between">
          <h2 className="font-bold text-lg">Menu</h2>
          <button onClick={() => setMenuOpen(false)}>✕</button>
        </div>

        <div className="px-4 space-y-4 text-sm">

          <Link to="/">Home</Link>

          {user ? (
            <>
              <Link to="/account/profile">My Account</Link>
              <Link to="/account/orders">Orders</Link>

              {user.role === "ADMIN" && (
                <Link to="/admin-panel/dashboard">Admin Panel</Link>
              )}

              <button onClick={handleLogout} className="text-red-500">
                Logout
              </button>
            </>
          ) : (
            <Link to="/login">Login</Link>
          )}

        </div>

      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0 bg-black/40 z-40"
        />
      )}

    </>
  );
};

export default Header;